<template>
  <header>
    <div class="b-share">
      <span>ПОДЕЛИТЬСЯ</span>
      <a
        class="b-share--item"
        :href="`https://vk.com/share.php?url=${$projectUrl}`"
        target="_blank"
      >ВКонтакте</a>
      <a
        class="b-share--item"
        :href="`https://www.facebook.com/sharer/sharer.php?u=${$projectUrl}`"
        target="_blank"
      >Facebook</a>
      <a
        class="b-share--item"
        :href="`https://twitter.com/intent/tweet?url=${$projectUrl}&text=Оценки конкурсных фильмов от жюри российских критиков. Российские кинокритики оценивают главные ленты фестиваля.`"
        target="_blank"
      >Twitter</a>
    </div>
    <div class="top">
      <div class="left">
        <h1 class="header-title">76-й ВЕНЕЦИАНСКИЙ <br/>КИНОФЕСТИВАЛЬ</h1>
      </div>
      <div class="right">
        <div class="logo-images">
          <a
            :href="`${$rootProject.link}`"
            class="logo-image logo-image--kino"
            :title="`${$rootProject.title}`"
            target="_blank"
          >
            <img :src="`${$rootProject.logo}`" :alt="`${$rootProject.title}`">
          </a>
          <a
            :href="`${$3dParty.venice2019.link}`"
            :title="`${$3dParty.venice2019.title}`"
            class="logo-image logo-image--venice2019"
            target="_blank"
          >
            <img :src="`${$3dParty.venice2019.logo}`" alt>
          </a>
        </div>
      </div>
    </div>
    <div class="bottom">
      <span>
        Оценки конкурсных фильмов
        <br>от жюри российских критиков
      </span>
    </div>
  </header>
</template>

<script>
export default {
  name: "b-header",
  inject: ["$rootProject", "$projectUrl", "$projectTitle", "$3dParty"]
};
</script>

<style scoped lang="sass">
  .header-title
    margin-bottom: 15px
  .b-share
    position: absolute
    right: 21px
    top: 21px
    width: 84px
    text-align: right
    &>*
      margin-bottom: 15px
      display: inline-block
      &:last-child
        margin-bottom: 0
    span
      width: 84px
      font-family: MenoeGrotesquePro
      font-size: 14px
      font-weight: normal
      font-style: normal
      font-stretch: normal
      line-height: 1.43
      letter-spacing: normal
      color: #828282
    &--item
      font-family: MenoeGrotesquePro
      font-size: 14px
      line-height: 1.43
      letter-spacing: normal
      color: #222222
      &:hover
        color: rgba(#222222, .6)
</style>



// WEBPACK FOOTER //
// src/views/includes/header.vue